type Props = {
  onClick: () => void;
  /** Packs being bought — drives the "Pack" / "Packs" label. */
  count: number;
  /** Formatted total for `count` packs; ignored when locked. */
  priceLabel: string;
  disabled: boolean;
  /** "Pack unavailable" / "Sold out" — replaces the buy label. */
  lockedLabel: string | null;
  /** The balance doesn't cover `count` packs — the button reads
   *  {@link DEPOSIT_LABEL} and the tap goes to the cashier. */
  isShortOfFunds: boolean;
};

const LABEL_SEPARATOR = ' • ';
/** Partner ask (Betr, 2026-10-23): no price — the player can't pay it yet. */
const DEPOSIT_LABEL = 'Deposit to rip';

function buyLabel(count: number, priceLabel: string): string {
  const packs = count === 1 ? 'pack' : 'packs';
  return `Buy ${count} ${packs}${LABEL_SEPARATOR}${priceLabel}`;
}

/**
 * Sleek's primary purchase action — a flat white button ("Buy 2 packs • $500")
 * that replaces modern's RIP disc (partner mockup, 2026-09), level with the
 * quantity stepper: both take the dock's button-height knob (52px, 14px
 * corners per the 2026-10-14 Figma).
 */
export function BuyButton({ onClick, count, priceLabel, disabled, lockedLabel, isShortOfFunds }: Props) {
  const label = lockedLabel ?? (isShortOfFunds ? DEPOSIT_LABEL : buyLabel(count, priceLabel));
  return (
    <button
      type="button"
      data-co-component="BuyButton"
      onClick={onClick}
      disabled={disabled}
      className="
        flex h-[var(--co-BottomActionShell-buttonHeight,52px)] min-w-0 flex-1 items-center justify-center px-4
        rounded-[14px] whitespace-nowrap text-[17px] leading-[24px] font-semibold tracking-[-0.43px]
        bg-[var(--co-BuyButton-fill,#F4F4F5)] text-[var(--co-BuyButton-text,#0E0F11)]
        cursor-pointer transition-transform active:scale-[0.98]
        disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100
      "
    >
      <span className="truncate">{label}</span>
    </button>
  );
}
